import { createFileRoute } from "@tanstack/react-router";

import TodosUploads from "@/features/todos/todos-uploads";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang/uploads",
)({
  component: PayableUploadsPage,
  staticData: {
    breadcrumb: ["todos.payable.title"],
  },
});

function PayableUploadsPage() {
  return <TodosUploads type="payable" />;
}
